import { render } from "./expertReviewBookingDetailsModal.vue?vue&type=template&id=f4613988&ts=true"
import script from "./expertReviewBookingDetailsModal.vue?vue&type=script&lang=ts"
export * from "./expertReviewBookingDetailsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__